import React, { Component } from "react";
import _ from "lodash";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import contentService from "../services/contentService";
import classNames from "classnames";
import { connect } from "react-redux";
import {
  WithStyles,
  createStyles,
  Grid,
  Typography,
  Checkbox,
  FormControl,
  Avatar,
  Button,
  Chip,
  MenuItem,
  ListItemText,
  Tooltip,
  Select,
  InputBase,
} from "@material-ui/core";
import NotificationListing from "./NotificationListing";
import ViewChallengePopup from "../components/ContentPreview/ChallengeQuestion/ViewChallengePopup";
import MyPATDialog from "../../common/MyPATDialog";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { MyPATLink, MyPATSelect } from "../../common";
import CheckBoxPopOver from "./CheckBoxPopOver";
import { MyPATMultiSelect } from "../../common/MyPATMultiSelect";
import ContentPagination from "../components/ContentPagination";
import { Category, PanoramaSharp } from "@material-ui/icons";

const styles = (theme: Theme) =>
  createStyles({
    notificationInfo: {
      background:
        "linear-gradient(91.97deg, rgba(245, 249, 255, 0.2) 16.85%, rgba(245, 249, 255, 0.16) 56.7%, rgba(190, 216, 255, 0.2) 92.79%), #FFFFFF",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      borderRadius: 8,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 50px 10px 22px",
    },
    mt40: {
      marginTop: "40px",
    },
    heading: {
      fontSize: 20,
      fontWeight: 600,
      color: "#333",
    },

    formControlLabel: {
      marginBottom: 6,
    },
    mtb20: {
      marginTop: 20,
      marginBottom: 15,
    },
    textRight: {
      textAlign: "right",
    },
    textCenter: {
      textAlign: "center",
    },
    Avtar: {
      background: "#6267E0",
      color: "#F5F4F4",
      marginTop: 0,
      marginRight: 6,
      marginBottom: 6,
      marginLeft: 25,
      textTransform: "uppercase",
    },
    userName: {
      fontSize: 16,
      fontWeight: 700,
      color: "#333",
      textTransform: "capitalize",
    },
    userType: {
      fontSize: 12,
      fontWeight: 600,
      color: "#666",
      padding: "5px 8px",
      background: "rgba(153, 153, 153, 0.1)",
      borderRadius: "3px",
      margin: "0 10px",
    },
    msgTime: {
      fontSize: 14,
      fontWeight: 400,
      color: "#666",
    },
    mb15: {
      marginBottom: "15px",
    },
    msgDetail: {
      fontSize: 16,
      fontWeight: 400,
      color: "#666",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    },
    CTA: {
      fontSize: 14,
      fontWeight: 600,
      color: "#1d7dea",
      cursor: "pointer",
      "& img": {
        marginLeft: "8px",
        verticalAlign: "middle",
      },
    },
    cardContainer: {
      background: "#FFFFFF",
      borderRadius: 8,
      padding: 15,
      marginBottom: "12px",
      minWidth: "100%",
    },
    // No data
    no_data: {
      margin: "150px 0",
      "& img": {
        marginBottom: 25,
        margin: "auto",
      },
      "& h5": {
        fontSize: 24,
        fontWeight: 500,
        color: "#333",
        margin: 0,
      },
    },
    status: {
      fontSize: 14,
      fontWeight: 400,
      color: "#666",
    },
    minHeight91: {
      minHeight: "91px",
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "space-between",
    },
    doneBtn: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "19px",
      backgroundColor: "#1d7dea",
      color: "#fff",
      wordSpacing: 0.5,
      padding: "9px 25px",
      "&:hover": {
        backgroundColor: "#1d7dea",
        color: "#fff",
      },
    },
    chip: {
      border: "1px solid #1D7DEA",
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "16px",
      padding: "6px 24px",
      margin: "0px 12px 12px 0px",
      background: "transparent",
      color: "#1d7dea",
      "&:hover": {
        color: "#1d7dea",
      },
      "&:focus": {
        backgroundColor: "tranparent",
        color: "#1d7dea",
      },
    },
    chipInactive: {
      backgroundColor: "transparent!important",
      color: "#999!important",
      borderColor: "#E6E6E6",
      "& span": {
        padding: "0px",
      },
    },
    chipActive: {
      borderColor: "#1d7dea",
      backgroundColor: "transparent!important",
      color: "#1d7dea",
      "& span": {
        padding: "0px",
      },
    },
    dialogHeading: {
      fontSize: "16px",
      lineHeight: "22px",
      color: "#666",
      textAlign: "left",
      margin: "0px 0 12px 0",
      display: "block",
    },
    minHeight: {
      minHeight: "325px",
    },
    qId: {
      fontSize: 16,
      fontWeight: 600,
      color: "#333",
      margin: "0px 0 15px 0",
      display: "block",
    },
    description: {
      fontSize: 16,
      fontWeight: 400,
      color: "#999",
      marginBottom: "30px",
      marginTop: "18px",
      wordBreak: "break-all",
      "& p": {
        margin: 0,
      },
    },
    attachmentHeading: {
      fontSize: 16,
      fontWeight: 400,
      color: "#666",
      marginBottom: "12px",
    },
    attachted_img: {
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap",
    },
    "a":{
      textDecoration: "none"
    },
    img_container: {
      cursor: "pointer",
      position: "relative",
      border: "1px solid #D1D1D1",
      width: 120,
      height: 120,
      borderRadius: 8,
      marginRight: 15,
      marginBottom: 35,
      textDecoration: "none",
      "& img": {
        width: "100%",
        height: "100%",
        borderRadius: 8,
      },
      "& a":{
        textDecoration: "none"
      },
      "& p": {
        fontSize: 10,
        fontWeight: 500,
        color: "#999",
        marginTop: 3,
        "& span": {
          minWidth: 6,
          maxWidth: 97,
          display: "inline-block",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          verticalAlign: "bottom",
        },
      },
    },
    viewMore: {
      position: "absolute",
      width: 120,
      height: 120,
      background: "rgba(0, 0, 0, 0.7)",
      border: "1px solid #D1D1D1",
      borderRadius: 8,
      fontSize: 16,
      fontWeight: 700,
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      top: 0,
    },
    toolBox: {
      position: "sticky",
      top: 0,
      zIndex: 99,
      background: "#FBFBFB",
      borderBottom: "1px solid #eee",
      marginTop: "-15px",
      right: 0,
      marginLeft: "auto",
      boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.12)",
      "& .arrow": {
        padding: "0px 3px 2px 2px",
        borderRadius: "50%",
        margin: "0px 4px",
        color: "#fff",
        cursor: "pointer",
        "&:hover": {
          background: "rgb(29 125 234)",
        },
      },
      "& .closeButton": {
        color: "#1d7dea",
        cursor: "pointer",
        verticleAlign: "middle",
        "& svg": {
          marginBottom: 2,
        },
      },
    },
    footerFixed: {
      position: "fixed",
      zIndex: 100,
      right: 0,
      width: "100%",
      bottom: 0,
      textAlign: "right",
      backgroundColor: "#ffffff",
      paddingRight: "26px",
      padding: "15px 24px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      // display: 'grid',
      gridTemplateColumns: "92% 8%",
      alignItems: "center",
      "& button": {
        padding: "10px 15px",
        // maxWidth: 140,
        // width: "100%",
      },
    },
    paddingBot50: {
      paddingBottom: 210,
    },
    displayFlex: {
      display: "flex",
    },
    actionContainer: {
      alignSelf: "flex-end",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      "& > *": {
        marginLeft: theme.spacing.unit * 2,
        minWidth: "58px",
      },
      "& img": {
        marginRight: 3,
      },
    },
    shareButton: {
      background: theme.palette.common.white,
    },
    blue: {
      border: "solid 1px #1D7DEA",
      boxSizing: "border-box",
      color: "#1D7DEA",
      fontWeight: 600,
    },
    copyButton: {
      background: theme.palette.common.white,
      "& .disabled": {
        opacity: 0.3,
      },
    },
    commentButton: {
      minWidth: "unset",
      padding: theme.spacing.unit + 2,
      "& img": {
        margin: "0 auto",
      },
    },
    sidePanel: {
      paddingRight: "30px !important",
      paddingTop: "30px !important",
      position: "sticky",
      top: "55px",
      "& .fullButton": {
        width: "100%",
      },
      "& .feedbackAction": {
        boxShadow: "none",
        background: "rgb(0 0 0 / 0%)",
        marginBottom: 0,
        padding: "10px 0px 10px",
      },
      "& > *": {
        marginBottom: theme.spacing.unit + 2,
        // boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
        borderRadius: 4,
      },
      "&": {
        width: "100%",
        height: "100%",
      },
    },
    paddingSet: {
      padding: "0 15px 0 0",
    },
    popupBlock: {
      width: "450px",
      textAlign: "center",
      "& p": {
        fontSize: "16px",
        "font-weight": "normal",
        lineHeight: "16px",
        textAlign: "center",
        letterSpacing: "0.144385px",
        color: "#000000",
        display: "block",
        paddingTop: "20px",
      },
    },
    headerCTA: {
      padding: "15px 34px 24px",
    },
    countcolor: {
      color: "#424A55",
    },
    backButton: {
      display: "block",
      lineHeight: theme.spacing.unit + "px",
      color: "#1d7dea",
      textDecoration: "none",
      fontWeight: "bold",
      cursor: "pointer",
      "& svg": {
        verticalAlign: "-4px",
      },
      "&:hover": {
        textDecoration: "none",
      },
    },
    ques_container: {
      borderTop: "1px solid #DFDFDF",
      padding: "22px 34px",
    },
    q_ID: {
      fontSize: 16,
      fontWeight: 700,
      color: "#333",
    },
    q_type: {
      background: "#FFFFFF",
      border: "1px solid #60768C",
      borderRadius: 10,
      fontWeight: 400,
      fontSize: 12,
      lineHeight: "10px",
      color: "#60768C",
      padding: "5px 12px",
      marginLeft: "10px",
    },
    ques: {
      width: "85%",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      marginLeft: 33,
      color: "#999",
      fontSize: 16,
      fontWeight: 400,
    },
    fileSize: {
      fontSize: 14,
      fontWeight: 400,
      color: "#999",
    },
    customSelect: {
      width: 183,
      marginLeft: "auto",
      "&>:first-child": {
        textAlign: "left",
        "&>:first-child": {
          "&>:first-child": {
            "&>:first-child": {
              fontSize: 14,
              fontWeight: 500,
              color: "#333",
            },
          },
        },
      },
    },
    checkedCheckbox: {
      backgroundColor: "#1d7dea!important",
      border: "1px solid #1d7dea !important",
      borderRadius: 2,
      color: "#99a1a7",
      "&::after": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 2,
        left: 7,
        width: 4,
        height: 10,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
      },
      "&:hover": {
        backgroundColor: "#1d7dea",
      },
    },
    checkBoxListElement: {
      padding: "0px 7px",
      top: 2,
      width: 6,
      height: 20,
      "-moz-appearance": "none",
      opacity: 1,
      color: "rgb(204, 204, 204)",
      border: "1px solid #B2B2B2",
      borderRadius: 4,
      margin: "-4px 0px 0px 0px",
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: '"Nunito", sans-serif',
        fill: "#979797",
        opacity: 0,
      },
    },
    checkboxLabel: {
      fontSize: 18,
      color: "#363636",
    },
    attachment_type: {
      marginRight: 15,
      textDecoration: "none",
      marginBottom: 15,
      display: "inline-block",
      "& p": {
        fontSize: 10,
        fontWeight: 500,
        color: "#999",
        marginTop: 3,
        "& span": {
          minWidth: 6,
          maxWidth: 97,
          display: "inline-block",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          verticalAlign: "bottom",
        },
      },
    },
  });

enum IssueArea {
  AMBIGIOUS_CONTENT = "Ambiguous Content",
  INCORRECT_OPTION_OR_ANSWER = "Incorrect Options/Answer",
  INCORRECT_SOLUTION = "Incorrect Solution",
  INCORRECT_CONCEPT = "Incorrect concept",
  INCORRECT_DIFFICULTY_OR_SKILL = "Incorrect Difficulty/Skill",
  INCORRECT_QUESTION = "Incorrect Question",
}

enum ChallengeModals {
  ADD_CHALLENGE,
  VIEW_CHALLENGE,
}
enum ChallengeStatus {
  OPEN = "open",
  ACCEPTED = "accepted",
  DISMISSED = "dismissed",
}
//@ts-ignore
interface sendNotificationProps extends WithStyles<typeof styles> {
  classes: any;
  searchText: string;
  history: any;
  match: any;
  searchTextChanged: Function;
}

interface sendNotificationState {
  currentlyOpenedModal: ChallengeModals | null;
  viewChallengeIndex: number;
  issueArea: IssueArea[];
  issueCategory: string[];
  pageNumber: number;
  totalCount: number;
  pageSize: number;
  checkedChallenges: string[];
  showMoreAttachments: boolean;
  selectAllChallenges: boolean;
  author: {
    questionReviews: any[];
  };
}

class SendNotification extends Component<
  sendNotificationProps,
  sendNotificationState
> {
  constructor(props: sendNotificationProps) {
    super(props);
    this.state = {
      issueArea: [IssueArea.AMBIGIOUS_CONTENT],
      currentlyOpenedModal: null,
      viewChallengeIndex: -1,
      issueCategory: [],
      pageNumber: 1,
      totalCount: 0,
      pageSize: 20,
      showMoreAttachments: false,
      selectAllChallenges: false,
      checkedChallenges: [],
      author: {
        questionReviews: [],
      },
    };
  }

  onClose = () => {
    this.setState({
      currentlyOpenedModal: null,
      viewChallengeIndex: -1,
      showMoreAttachments: false,
    });
  };

  getFilteredContent = () => {
    this.setState({ pageNumber: 1 });

    const params: any = {
      questionId: this.props.match.params.questionId,
      reviewerType: "all",
      reviewStatus: "open,accepted",
      pageNumber: 1,
      pageSize: this.state.pageSize,
    };
    if (this.props.match.params.reviewerId) {
      params.reviewerId = this.props.match.params.reviewerId;
    }

    const arr = [...this.state.issueCategory];
    let filterstr = arr.join(",");
    if (arr.length >= 6) {
      filterstr = "";
    }

    if (filterstr) {
      params.issueTypes = filterstr;
    }

    contentService.getQuestionReviews(params).then((data) => {
      var author = { ...this.state.author };
      author.questionReviews = data.questionReviews;
      this.setState({ author });
      this.setState({ totalCount: data.totalRecords });
    });
  };

  componentDidMount = () => {
    const challengeCreators: string | any[] = ["all"];

    for (let i = 0; i < challengeCreators.length; i++) {
      const params: any = {
        questionId: this.props.match.params.questionId,
        reviewerType: challengeCreators[i],
        reviewStatus: "open,accepted",
        pageNumber: 1,
        pageSize: this.state.pageSize,
      };
      if (this.props.match.params.reviewerId) {
        params.reviewerId = this.props.match.params.reviewerId;
        params.reviewerType = "all";
      }
      contentService.getQuestionReviews(params).then((data) => {
        var author = { ...this.state.author };
        author.questionReviews = data.questionReviews;
        this.setState({ author });
        this.setState({ totalCount: data.totalRecords });
      });
    }
  };

  openViewChallengeModal = (index: number) => {
    this.setState({
      currentlyOpenedModal: ChallengeModals.VIEW_CHALLENGE,
      viewChallengeIndex: index,
    });
  };

  handleDialogClose = () => {
    this.setState({
      currentlyOpenedModal: null,
      viewChallengeIndex: -1,
    });
  };

  getAttachmentsCount = () => {
    if (
      this.state.author.questionReviews[this.state.viewChallengeIndex]
        .attachments.length > 1
    ) {
      return `${
        this.state.author.questionReviews[this.state.viewChallengeIndex]
          .attachments.length
      } Files Attached`;
    } else {
      return `${
        this.state.author.questionReviews[this.state.viewChallengeIndex]
          .attachments.length
      } File Attached`;
    }
  };

  handleConceptMultiSelect(event: any) {
    this.setState({ checkedChallenges: [], selectAllChallenges: false });
    let newIssueCategory = [...this.state.issueCategory];

    // handling the filter selecting conditions
    //getting the currently checked element
    let currentlyChecked = [];
    let currentlyUnchecked: string[] = [];
    if (this.state.issueCategory.length > event.target.value.length) {
      currentlyUnchecked = this.state.issueCategory.filter(
        (category: string) => !event.target.value.includes(category)
      );
    } else {
      currentlyChecked = event.target.value.filter(
        (category: string) => !this.state.issueCategory.includes(category)
      );
    }

    if (currentlyChecked[0] === "All") {
      newIssueCategory = [
        "All",
        IssueArea.AMBIGIOUS_CONTENT,
        IssueArea.INCORRECT_OPTION_OR_ANSWER,
        IssueArea.INCORRECT_SOLUTION,
        IssueArea.INCORRECT_QUESTION,
        IssueArea.INCORRECT_DIFFICULTY_OR_SKILL,
        IssueArea.INCORRECT_CONCEPT,
      ];
    } else if (currentlyUnchecked.length > 1) {
      if (currentlyUnchecked.includes("All")) {
        newIssueCategory = [];
      } else {
        newIssueCategory = [...currentlyUnchecked];
        newIssueCategory = newIssueCategory.filter(
          (category) => category !== "All"
        );
      }
    } else if (currentlyUnchecked.length) {
      newIssueCategory = newIssueCategory.filter(
        (category) => category !== currentlyUnchecked[0]
      );
    } else {
      newIssueCategory.push(currentlyChecked[0]);
      if (newIssueCategory.length === 6) {
        newIssueCategory.push("All");
      }
    }

    this.setState({ issueCategory: newIssueCategory }, () => {
      this.getFilteredContent();
    });
  }

  nextPage = (e: any, page: number) => {
    this.setState({ pageNumber: page });
    setTimeout(() => {
      this.loadContentList();
    }, 200);
  };

  loadContentList = () => {
    const params: any = {
      questionId: this.props.match.params.questionId,
      reviewerType: "all",
      reviewStatus: "open,accepted",
      pageNumber: this.state.pageNumber,
      pageSize: this.state.pageSize,
    };
    if (this.props.match.params.reviewerId) {
      params.reviewerId = this.props.match.params.reviewerId;
    }

    const arr = [...this.state.issueCategory];
    const filterstr = arr.join(",");

    if (filterstr) {
      params.issueTypes = filterstr;
    }

    contentService.getQuestionReviews(params).then((data) => {
      var author = { ...this.state.author };
      author.questionReviews = data.questionReviews;
      this.setState({ author });
    });
  };

  markResolved = () => {
    const payload: any = {
      questionId: this.props.match.params.questionId,
      questionReviewIds: this.state.checkedChallenges,
    };
    if (this.props.match.params.reviewerId) {
      payload.reviewerId = this.props.match.params.reviewerId;
    }
    if (this.state.selectAllChallenges) {
      payload.questionReviewIds = [];
    }

    contentService.markAsResolved(payload).then((res: any) => {
      if (res.statusCode === 200) {
        this.props.history.push(
          `/content/preview/${this.props.match.params.questionId}question`
        );
      }
    });
  };

  handleSelectAll = (checked: boolean, pageNumber: number) => {
    if (pageNumber) {
      if (checked) {
        const challenges = new Set([...this.state.checkedChallenges]);
        this.state.author.questionReviews.forEach((review) => {
          challenges.add(review._id);
        });
        this.setState({
          checkedChallenges: Array.from(challenges),
          selectAllChallenges: false,
        });
      } else {
        const challenges = new Set([...this.state.checkedChallenges]);
        this.state.author.questionReviews.forEach((review) => {
          if (challenges.has(review._id)) {
            challenges.delete(review._id);
          }
        });
        this.setState({
          checkedChallenges: Array.from(challenges),
          selectAllChallenges: false,
        });
      }
    } else {
      this.setState({ selectAllChallenges: checked });
      if (!checked) {
        this.setState({ checkedChallenges: [] });
      }
    }
  };

  checkBoxClicked = (id: string) => {
    const challenges = new Set([...this.state.checkedChallenges]);
    if (challenges.has(id)) {
      challenges.delete(id);
    } else {
      challenges.add(id);
    }
    this.setState({ checkedChallenges: Array.from(challenges) });
  };

  skip = () => {
    const { history } = this.props;
    history.push(
      `/content/preview/${this.props.match.params.questionId}question`
    );
  };

  backToEdit = () => {
    const { history } = this.props;
    history.push(
      `/content/edit/question/${this.props.match.params.questionCode}/${
        this.props.match.params.questionId
      }question`
    );
  };

  showMoreImgs = () => {
    this.setState({ showMoreAttachments: true });
  };

  getFileNameFromUrl = (url: string) => {
    const arr = url.split("/");
    const fileName = arr[arr.length - 1].split(".");
    return fileName[0];
  };

  getFileExtension = (url: string) => {
    const arr = url.split(".");
    return arr[arr.length - 1];
  };

  render() {
    const { classes } = this.props;
    const { author, viewChallengeIndex, pageNumber, totalCount } = this.state;

    const arr: string[] = [
      "All",
      IssueArea.AMBIGIOUS_CONTENT,
      IssueArea.INCORRECT_OPTION_OR_ANSWER,
      IssueArea.INCORRECT_SOLUTION,
      IssueArea.INCORRECT_CONCEPT,
      IssueArea.INCORRECT_DIFFICULTY_OR_SKILL,
      IssueArea.INCORRECT_QUESTION,
    ];

    return (
      <>
        {/* cms notification header */}
        <Grid className={classes.toolBox}>
          <Grid
            container
            alignItems="center"
            justify="space-between"
            className={classes.headerCTA}
          >
            <Grid item className={classes.backButton} onClick={this.backToEdit}>
              <ChevronLeftIcon>chevron_left</ChevronLeftIcon> Back to Edit
            </Grid>
            <Grid item className={classes.actionContainer}>
              <ContentPagination
                className={classes.countcolor}
                classes={{ root: classes.inlineBlock }}
                page={pageNumber}
                count={totalCount}
                rowsPerPage={this.state.pageSize}
                onChangePage={this.nextPage}
              />
              <Button
                variant="outlined"
                color="primary"
                disabled={
                  !!(
                    this.state.checkedChallenges.length ||
                    this.state.selectAllChallenges
                  )
                }
                onClick={this.skip}
              >
                Skip
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={
                  !(
                    this.state.checkedChallenges.length ||
                    this.state.selectAllChallenges
                  )
                }
                onClick={this.markResolved}
              >
                Mark As Resolved
              </Button>
            </Grid>
          </Grid>
          {/* Question Area */}
          <Grid
            container
            alignItems="center"
            justify="flex-start"
            className={classes.ques_container}
          >
            <Typography className={classes.q_ID}>
              {this.props.match.params.qId}
            </Typography>
            <Typography className={classes.q_type}>
              {this.props.match.params.questionType}
            </Typography>
            <Typography className={classes.ques}>
              <Tooltip title="Quest will show here" placement="top">
                <>{this.props.match.params.questionData}</>
              </Tooltip>
            </Typography>
          </Grid>
        </Grid>
        {/* Checkbox */}
        <Grid container spacing={0} className={classes.mt40}>
          <Grid item xs={12}>
            <Grid container justify="center">
              <Grid item xs={7}>
                <Grid item xs={12}>
                  <Grid item className={classes.notificationInfo}>
                    <Typography className={classes.heading}>
                      Please select users to send notification who reported this
                      question.
                    </Typography>
                    <img src="/assets/svg/notification-white-icon.svg" />
                  </Grid>

                  <Grid
                    container
                    justify="space-between"
                    alignItems="center"
                    className={classes.mtb20}
                  >
                    <Grid item xs={6}>
                      {/* Checkbox select */}
                      <CheckBoxPopOver
                        totalQuestionCount={totalCount}
                        currentPageNumber={pageNumber}
                        handleSelectAll={this.handleSelectAll}
                        issueCategory={this.state.issueCategory}
                        questionReviews={author.questionReviews}
                        checkedChallenges={this.state.checkedChallenges}
                        selectAllChallenges={this.state.selectAllChallenges}
                      />
                    </Grid>
                    <Grid item xs={6} className={classes.textRight}>
                      <div className={classes.customSelect}>
                        <MyPATSelect
                          multiple={true}
                          isNative={false}
                          fullWidthControl
                          className={classNames(classes.margin)}
                          name="questionCodes"
                          value={
                            this.state.issueCategory.includes("All")
                              ? ["All"]
                              : this.state.issueCategory
                          }
                          onChange={this.handleConceptMultiSelect.bind(this)}
                          // customRenderFunc={this.renderQuestion}
                          displayEmpty
                          placeholder={
                            <Typography
                              variant="body2"
                              align="left"
                              inline
                              className={classes.greyText}
                            >
                              All
                            </Typography>
                          }
                          required
                        >
                          {arr.map((issue, index) => (
                            <MenuItem value={issue} key={index}>
                              <Checkbox
                                color="primary"
                                classes={{
                                  root: classes.checkBoxListElement,
                                  checked: classes.checkedCheckbox,
                                  colorPrimary: classes.primaryColor,
                                }}
                                checked={this.state.issueCategory.includes(
                                  issue
                                )}
                              />
                              <ListItemText primary={issue} />
                            </MenuItem>
                          ))}
                        </MyPATSelect>
                      </div>
                    </Grid>
                  </Grid>
                  {/* Listing */}
                  <Grid container justify="center" direction="row">
                    {author.questionReviews.map((review: any, i) => {
                      return (
                        <NotificationListing
                          key={i}
                          review={review}
                          classes={undefined}
                          viewIndex={i}
                          onViewFull={this.openViewChallengeModal}
                          currentPageNumber={pageNumber}
                          checkBoxClicked={this.checkBoxClicked}
                          challengeId={review._id}
                          checkedChallenges={this.state.checkedChallenges}
                          selectAllChallenges={this.state.selectAllChallenges}
                        />
                      );
                    })}
                    {!author.questionReviews.length && (
                      <Grid item className={classes.cardContainer}>
                        <Grid
                          container
                          justify="center"
                          className={classes.no_data}
                        >
                          <Grid item className={classes.textCenter}>
                            <img src="/assets/svg/myLibrary/noData.svg" />
                            <h5>No challenges for the Selected Filter!</h5>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* View challange */}
        {this.state.currentlyOpenedModal === ChallengeModals.VIEW_CHALLENGE && (
          <ViewChallengePopup
          open={this.state.currentlyOpenedModal === ChallengeModals.VIEW_CHALLENGE}
          data={author.questionReviews[viewChallengeIndex]}
          // onDismiss={this.onDismiss}
          // onAccept={this.onAccept}
          onClose={this.handleDialogClose}
          contentId={this.props.match.params.qId}
        />
        )}
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(SendNotification);
